export const RESIDENT_RULES = {
    snils: {
        value: /^\d{11}$/,
        message: "СНИЛС должен содержать 11 цифр",
    },
    inn: { value: /^(?:\d{10}|\d{12})$/, message: "ИНН должен содержать 10 или 12 цифр" },
    bik: { value: /^\d{9}$/, message: "БИК должен содержать 9 цифр" },
    kpp: { value: /^\d{9}$/, message: "КПП должен содержать 9 цифр" },
    account: { value: /^\d{20}$/, message: "Р/С должен содержать 20 цифр" },
};
